// extracted by mini-css-extract-plugin
export default {"container":"About_container__GjPdO","imgContainer":"About_imgContainer__2UQjF","img":"About_img__q6xXN","text":"About_text__sCbc3"};